module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var u = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(u.exports, u, u.exports, r), u.l = !0, u.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var u in e) {
      r.d(n, u, function (t) {
        return e[t];
      }.bind(null, u));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 0);
}([function (e, t, r) {
  "use strict";

  var n = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u = n(r(1));
  t.default = u.default;
}, function (e, t, r) {
  "use strict";

  var n = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var r in e) {
      Object.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u = n(r(2)),
      a = r(3);
  t.CurrencyInput = function (e) {
    var t = e.allowDecimals,
        r = void 0 === t || t,
        n = e.id,
        o = e.name,
        l = e.className,
        i = e.decimalsLimit,
        c = void 0 === i ? 2 : i,
        f = e.defaultValue,
        s = e.onChange,
        d = e.placeholder,
        p = e.prefix,
        m = f ? a.formatValue(String(f), p) : "",
        v = u.useState(m),
        b = v[0],
        _ = v[1],
        y = u.useState(0),
        g = y[0],
        h = y[1],
        O = u.useRef(null);
    return u.useEffect(function () {
      O && O.current && O.current.setSelectionRange(g, g);
    }, [g, O, b]), u.default.createElement("input", {
      type: "string",
      id: n,
      name: o,
      className: l,
      onChange: function onChange(e) {
        var t = e.target,
            n = t.selectionStart,
            u = t.value,
            l = a.cleanValue(u, r, c, p);
        if (!l) return s(null, o), _("");

        if (a.checkIsValidNumber(l)) {
          var i = a.formatValue(l, p);

          if (n) {
            var f = n + (i.length - u.length) || 1;
            h(f);
          }

          _(i);
        }

        s(Number(l), o);
      },
      onFocus: function onFocus() {
        return b ? b.length : 0;
      },
      placeholder: d,
      value: b,
      pattern: "[0-9]+([\\.,][0-9]+)?",
      ref: O
    });
  }, t.default = t.CurrencyInput;
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.addCommas = function (e) {
    return e.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }, t.removeCommas = function (e) {
    return e.replace(/,/g, "");
  }, t.checkIsValidNumber = function (e) {
    return !(Number(e) < 0 || isNaN(Number(e)));
  }, t.cleanValue = function (e, r, n, u) {
    var a = u ? e.replace(u, "") : e,
        o = t.removeCommas(a);

    if (o.includes(".")) {
      var l = o.split("."),
          i = l[0],
          c = l[1];
      return "" + i + (r ? "." + (n ? c.slice(0, n) : c) : "");
    }

    return o;
  }, t.formatValue = function (e, r) {
    var n = e.split("."),
        u = n[0],
        a = n[1],
        o = r || "",
        l = e.includes(".") ? "." + a : "";
    return "" + o + t.addCommas(u) + l;
  };
}]);